/* src/app/pages/clubs/club-members/club-members.page.scss */
ul {
  padding: 0px;
  margin: 0px;
}
ul.rating li {
  padding: 0px 5px 0px 0px !important;
  background: none;
  color: #347b8f;
}
ul.rating li ion-icon {
  font-size: 18px;
}
.positioner {
  position: relative;
  left: -25px;
  top: -23px;
  color: var(--ion-color-exme-yellow-light);
}
.ribbon-icon {
  position: absolute;
  right: -30px;
  bottom: -20px;
}
ion-radio {
  --border-radius: 4px;
  --inner-border-radius: 4px;
}
ion-radio.ios {
  width: 20px;
  height: 20px;
  border: solid 2px;
  border-radius: 4px;
}
ion-radio.md {
  width: 20px;
  height: 20px;
  border: 2px;
  border-radius: 4px;
}
.text {
  color: var(--ion-color-black-white);
}
.collection-thumbnail {
  border-radius: 20%;
}
.absolute {
  position: absolute;
}
.ion-avatar-img {
  width: 150px;
  height: 150px;
}
.img-avatar {
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 5px gray;
}
.image-center {
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.toolbar-container {
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  align-items: center;
}
.toolbar-title {
  min-width: 0;
  padding: 0;
}
.radio-text-small {
  font-size: 14px;
  margin: 0;
}
.radio {
  height: 100% !important;
}
/*# sourceMappingURL=club-members.page.css.map */
